"use client";

import { createContext, useCallback, useContext, useRef } from "react";

/** @type {React.Context<{
 *   registerArActivator: (fn: () => void | Promise<void>) => () => void;
 *   tryActivateAr: () => Promise<boolean>;
 * } | null>} */
const ProductArContext = createContext(null);

export function ProductArProvider({ children }) {
  const activatorRef = useRef(null);

  const registerArActivator = useCallback((fn) => {
    activatorRef.current = fn;
    return () => {
      if (activatorRef.current === fn) {
        activatorRef.current = null;
      }
    };
  }, []);

  const tryActivateAr = useCallback(async () => {
    if (!activatorRef.current) return false;

    try {
      await activatorRef.current();
      return true;
    } catch {
      return false;
    }
  }, []);

  return (
    <ProductArContext.Provider value={{ registerArActivator, tryActivateAr }}>
      {children}
    </ProductArContext.Provider>
  );
}

export function useProductArContext() {
  return useContext(ProductArContext);
}
